module.exports = __webpack_public_path__ + "static/media/XButtonFilled.01377703.svg";